export default {
  REQUIRED_FIELD: 'validation-messages.field-required',

  Employee: {
    BIRTH_GREATER_THAN_DEATH: 'validation-messages.employee.date-of-birth-may-not-exceed-death',
    INITIALS_INVALID_FORMAT: 'validation-messages.employee.initials-invalid-format'
  },

  EmploymentRelationship: {
    FROM_DATE_GREATER_THAN_UNTIL_DATE: 'validation-messages.employment-relationship.from-date-greater-than-until-date',
    EMPLOYEE_NUMBER_EXCEED_CHAR_LIMIT: 'validation-messages.employment-relationship.employee-number-exceed-char-limit',
    CANNOT_BE_ABSENT_ON_FROM_DATE: 'validation-messages.employment-relationship.cannot-be-absent-on-from-date'
  },

  DisabilityRate: {
    FORMAT_INVALID: 'validation-messages.disability-rate-format-invalid',
    VALUE_TOO_HIGH: 'validation-messages.disability-rate-value-too-high',
    VALUE_TOO_LOW: 'validation-messages.disability-rate-value-too-low',
    VALUE_EQUAL_TO_PREVIOUS: 'validation-messages.disability-rate-value-equal-to-previous'
  },

  ReportOfSickness: {
    DisabilityRate: {
      FORMAT_INVALID: 'validation-messages.disability-rate-format-invalid',
      VALUE_TOO_HIGH: 'validation-messages.disability-rate-value-too-high',
      VALUE_TOO_LOW: 'validation-messages.disability-rate-value-too-low',
      VALUE_EQUAL_TO_PREVIOUS: 'validation-messages.disability-rate-value-equal-to-previous'
    },
    NO_VALUE_WAS_CHANGED: 'validation-messages.report-of-sickness.no-value-was-changed'
  },

  Recovery: {
    NO_VALUE_WAS_CHANGED: 'validation-messages.recovery.no-value-was-changed'
  },

  Period: {
    NO_VALUE_WAS_CHANGED: 'validation-messages.period.no-value-was-changed'
  }
};
